
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"810","height":"540"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FCDD09","d":"M0 0h810v540H0z"}}),_c('path',{attrs:{"stroke":"#DA121A","stroke-width":"60","d":"M0 90h810m0 120H0m0 120h810m0 120H0"}})])
          )
        }
      }
    